<template>
  <!-- prettier-ignore -->
  <div class="container_menu">
    <!-- <div class="menu">
      <p class="menu-title">资源来源</p>
      <ul class="menu-list">
        <el-checkbox-group v-model="sourceList" @change="getResouceVal">
          <li v-for="(item, idx) in showLetterFlag ? resoceList : resoceListArticle" :key="idx">
            <el-checkbox :label="item.value" :key="idx">
              <span class="line1">{{ item.label }}</span>
            </el-checkbox>
          </li>
        </el-checkbox-group>
      </ul>
    </div> -->
    <div class="menu-letter" v-show="showLetterFlag">
      <p class="menu-title">首字母</p>
      <p class="menu-num" :class="{ checked: letterNum == 26 }" @click="handleChangeLetter(26, '0-9')">0-9</p>
      <ul class="flex menu-ul">
        <li :class="{ checked: letterNum == index }" v-for="(item, index) in letterList" :key="index" @click="handleChangeLetter(index, item)">
          {{ item }}
        </li>
      </ul>
      <p class="menu-other" :class="{ checked: letterNum == 27 }" @click="handleChangeLetter(27, '其他')">其他</p>
    </div>

    <div class="menu" v-for="(item, index) in leftDataGroup" :key="index">
      <div v-if="item.name == '学科分区' || item.name == '外文学科'  || item.name == '教育部学科'" class="firstdiv">
        <p class="menu-title flex">
          {{ item.name }}
          <span v-if="item.items.length > 5" class="expand-text" @click="handleDrop(index, item.drop)" style="margin-left: auto; cursor: pointer; color: #666; font-size: 12px;">
            {{ item.drop ? '收起' : '更多' }}
          </span>
          <!-- <i v-if="item.items.length > 5" :class="item.drop ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" @click="handleDrop(index, item.drop)"></i> -->
        </p>
        <el-checkbox-group v-model="checkedGroup" @change="getGrop">
        <ul class="menu-list">
          <li class="check-item" v-for="(el, i) in item.items" :key="i" v-show="i < item.dropNum">
            <div class="flex firstcheck" @click="el.subItems && el.subItems.length > 0 && showChecked(item,i)">
              <img
                :class="{ hidden: !el.subItems || el.subItems.length == 0 }"
                v-if="!el.showFlag"
                @click.stop="showTwoCheckedPlus(item,i)"
                :src="jiaImg"
              />
              <img v-else :src="jianImg" @click.stop="showTwoCheckedMinus(item,i)" />
              <div v-if="el.subItems && el.subItems.length > 0" class="facet-parent-label">
                <span class="tag-name" :title="el.name">{{ el.name }}</span>
                <span class="menu-result">{{ el.result }}</span>
              </div>
              <el-checkbox v-else :label="el.onlyFlag" :disabled="!el.filterField">
                <span class="tag-name" :title="el.name" @click.stop.prevent="showChecked(item,i)">{{ el.name }}</span>
                <span class="menu-result" @click.stop.prevent="showChecked(item,i)">{{ el.result }}</span>
              </el-checkbox>
            </div>

            <ul v-if="el.subItems && el.subItems.length > 0 && el.showFlag">
                <li class="menu-two" v-for="(element, idx) in el.subItems" :key="idx">
                  <el-checkbox :label="element.onlyFlag" :key="idx">
                    <span class="line1">{{ element.name }}</span>
                    <span class="menu-result">{{ element.result }}</span>
                  </el-checkbox>
                </li>
            </ul>
          </li>
        </ul>
        </el-checkbox-group>
      </div>
      <div v-else>
        <p class="menu-title flex">
          {{ item.name }}
           <span v-if="item.items.length > 5" class="expand-text" @click="handleDrop(index, item.drop)" style="margin-left: auto; cursor: pointer; color: #666; font-size: 12px;">
            {{ item.drop ? '收起' : '更多' }}
          </span>
          <!-- <i v-if="item.items.length > 5" :class="item.drop ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" @click="handleDrop(index, item.drop)"></i> -->
        </p>
        <ul class="menu-list">
          <el-checkbox-group v-model="checkedGroup" @change="getGrop">
            <li v-for="(element, idx) in item.items" :key="idx" v-show="idx < item.dropNum">
              <el-checkbox :label="element.onlyFlag" :key="idx">
                <span class="line1">{{ element.name }}</span>
                <span class="menu-result">{{ element.result }}</span>
              </el-checkbox>
            </li>
          </el-checkbox-group>
        </ul>
      </div>
    </div>
    <!-- <div class="fixed" @click="handleCheckedGroup">
      执行限定条件<span v-show="checkedGroup.length > 0">{{ checkedGroup.length }}</span>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "LeftMenu",
  props: {
    leftData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    delName: {
      type: Object,
    },
    delSourceFrom: {
      type: Number,
    },
    delAll: {
      type: Number,
    },
    //是否显示首字母聚合
    showLetterFlag: {
      type: Boolean,
      default: false,
    },
    // 预选中的学科信息
    preSelectedSubject: {
      type: Object,
      default: null,
    },
  },
  watch: {
    leftData: {
      immediate: true,
      handler(val) {
      if (window.config && window.config.type == "oa") {
        //配置中config.js文件 oa过滤  show不过滤
        val.forEach((element, index) => {
          if (element.name == "资源来源") {
            val.splice(index, 1);
          }
        });
      }

      this.leftDataGroup = this.normalizeFilterGroups(val);
      this.leftDataGroupCopy = JSON.parse(JSON.stringify(this.leftDataGroup)); // 使用相同的稳定选项标识
      this.readNum++;
      // 新增：数据更新后处理展开状态
      this.$nextTick(() => {
        // 使用$set确保响应式
        this.leftDataGroup.forEach(item => {
          item.items.forEach((el, i) => {
            if (el.subItems?.some(sub => this.checkedGroup.includes(sub.onlyFlag))) {
              this.$set(item.items[i], "showFlag", true);
            }
          });
        });
        // 处理预选中学科
        if (this.preSelectedSubject && this.checkedGroup.length === 0) {
          this.selectSubjectByInfo(this.preSelectedSubject);
        }
      });
      },
    },
    delAll(val) {
      this.checkedGroup = [];
      this.checkedLetterName = "";
      this.letterNum = null;
      this.sourceList = [];
    },
    delName(val) {
      if (!val || !val.onlyFlag) {
        return;
      }

      this.removeFilterItem(val);
    },
    delSourceFrom(val) {
      this.sourceList = this.sourceList.filter(item => {
        return item != val;
      });
      this.getResouceVal();
    },
    // 监听预选中学科信息
    preSelectedSubject(val) {
      if (val && this.leftDataGroup.length > 0) {
        this.selectSubjectByInfo(val);
      }
    },
  },
  data() {
    return {
      readNum: 0,
      checkedGroup: [], //存储选中的checkbox
      leftDataGroup: [],
      leftDataGroupCopy: [], //左侧距和副本  当左侧距和为空时有用
      letterList: [], //存储26个字母
      letterNum: null, //存储26个字母中点击的索引
      checkedLetterName: "", //存储选中的首字母名称
      filterArray: [], //根据选中的 获取到选中的过滤对象
      resoceList: [
        {
          value: 1,
          label: "加入馆外资源更多结果",
        },
      ],
      resoceListArticle: [
        // {
        //   value: 1,
        //   label: "加入馆外资源更多结果",
        // },
        {
          value: 1,
          label: "加入馆外非开放获取",
        },
      ],
      sourceList: [],
      jiaImg: require("@/assets/images/icon-zk01.png"),
      jianImg: require("@/assets/images/icon-zk02.png"),
    };
  },
  mounted() {
    // 加入馆外非开放获取 勾选
    if (JSON.parse(sessionStorage.getItem("joinChecked"))) {
      this.sourceList = [1];
    } else {
      this.sourceList = [];
    }
    this.getAlphabet();

    // 如果有预选中的学科信息且左侧数据已加载，执行预选中
    if (this.preSelectedSubject && this.leftData.length > 0) {
      this.$nextTick(() => {
        this.selectSubjectByInfo(this.preSelectedSubject);
      });
    }
  },
  methods: {
    normalizeFilterGroups(groups) {
      const copy = JSON.parse(JSON.stringify(groups));
      const counts = new Map();
      const visit = (nodes, callback) => nodes.forEach(node => {
        callback(node);
        if (node.subItems) visit(node.subItems, callback);
      });
      copy.forEach(group => visit(group.items, node => {
        if (node.onlyFlag !== undefined && node.onlyFlag !== null && node.onlyFlag !== "") {
          counts.set(node.onlyFlag, (counts.get(node.onlyFlag) || 0) + 1);
        }
      }));
      copy.forEach(group => visit(group.items, node => {
        if (counts.get(node.onlyFlag) !== 1) {
          node.onlyFlag = "facet:" + JSON.stringify([group.name, node.filterField, node.filterValue, node.name]);
        }
      }));
      return copy;
    },
    getResouceVal() {
      this.$emit("sourceByValue", this.sourceList);
    },
    getGrop() {
      if (this.checkedGroup.length > 5) {
        this.checkedGroup = this.checkedGroup.slice(0, 5);
        this.$message.warning("限定条件不能超过5个");
      }

      // 检查是否取消了预选中的学科
      if (this.preSelectedSubject && this.preSelectedSubject.name) {
        // 查找对应的外文学科项的onlyFlag
        let preSelectedOnlyFlag = null;
        this.leftDataGroup.forEach(item => {
          if (item.name === "外文学科") {
            item.items.forEach(el => {
              if (el.name === this.preSelectedSubject.name) {
                preSelectedOnlyFlag = el.onlyFlag;
              }
            });
          }
        });

        // 如果找到了对应的onlyFlag，检查是否被取消选中
        if (preSelectedOnlyFlag && !this.checkedGroup.includes(preSelectedOnlyFlag)) {
          // 如果预选中的学科被取消，清理相关信息
          this.preSelectedSubject = null;
          // 通知父组件清理sessionStorage
          this.$emit("clearPreSelectedSubject");
        }
      }

      // 添加强制更新视图并保持展开状态
      this.$nextTick(() => {
        this.handleCheckedGroup();
        this.$forceUpdate(); // 强制更新视图保持展开状态
      });
    },
    getAlphabet() {
      //获取26个字母
      this.letterList = Array.from(new Array(26), (ele, index) => {
        return String.fromCharCode(65 + index);
      });
    },
    // 左侧聚合  第一级展开
    showChecked(item, i) {
      const option = item.items[i];
      if (!option.subItems || option.subItems.length === 0) {
        if (!option.filterField) return;
        const index = this.checkedGroup.indexOf(option.onlyFlag);
        if (index === -1) this.checkedGroup.push(option.onlyFlag);
        else this.checkedGroup.splice(index, 1);
        this.getGrop();
        return;
      }
      if (!item.items[i].showFlag) {
        this.showTwoCheckedPlus(item, i); // 增加item参数传递
      } else {
        this.showTwoCheckedMinus(item, i); // 增加item参数传递
      }
    },
    showTwoCheckedPlus(item, i) {
      let children = item.items[i].subItems; // 修正为操作当前item
      if (children) {
        item.items[i].showFlag = true;
      }
      this.$forceUpdate();
    },
    showTwoCheckedMinus(item, i) {
      let children = item.items[i].subItems; // 修正为操作当前item
      if (children) {
        item.items[i].showFlag = false;
      }
      this.$forceUpdate();
    },
    handleDrop(index, flag) {
      //如果是展开状态 - 收起
      if (flag) {
        this.$set(this.leftDataGroup[index], "drop", false);
        this.leftDataGroup[index].dropNum = 5;
        return;
      }
      if (this.leftDataGroup[index].name == "学科分区" || this.leftDataGroup[index].name == "外文学科") {
        //学科分类 展开全部
        this.leftDataGroup[index].dropNum = this.leftDataGroup[index].items.length;
      } else {
        //除学科分类  最多展开20条
        this.leftDataGroup[index].dropNum = 20;
        // this.leftDataGroup[index].dropNum = this.leftDataGroup[index].items.length;
      }
      this.$set(this.leftDataGroup[index], "drop", true);
    },
    // 首字母点击切换
    handleChangeLetter(index, data) {
      this.letterNum = index;
      if (this.checkedLetterName) {
        if (this.checkedLetterName.name == data) {
          //选择的如果已经是被选中的  取消选中
          let idx = this.checkedGroup.findIndex(item => item === "nameFirst" + data);
          this.checkedLetterName = null;
          this.letterNum = null;
          this.checkedGroup.splice(idx, 1);
          this.handleCheckedGroup();
          return;
        }
        //根据存储的首字母名字  删除数组里已有的
        this.checkedGroup.forEach((element, index) => {
          if (element == this.checkedLetterName.onlyFlag) {
            this.checkedGroup.splice(index, 1);
          }
        });
      }
      if (this.checkedGroup.length >= 5) {
        this.letterNum = null;
        this.$message.warning("限定条件不能超过5个");
        return;
      }

      this.checkedGroup.push("nameFirst" + data);
      //获取到选择的首字母项
      this.checkedLetterName = {
        filterField: "nameFirst",
        filterValue: [data],
        fatherName: "首字母",
        onlyFlag: "nameFirst" + data,
        name: data,
      };
      this.handleCheckedGroup();
    },
    handleCheckedGroup() {
      this.filterArray = [];
      this.checkedGroup.forEach(element => {
        this.leftDataGroupCopy.forEach((item, index) => {
          item.items.forEach(ele => {
            ele.fatherName = item.name;
            if (element != null && element !== "" && element === ele.onlyFlag && ele.filterField && (!ele.subItems || ele.subItems.length === 0)) {
              this.filterArray.push(ele);
            }
            // 新增：检查二级分类
            if (ele.subItems && ele.subItems.length > 0) {
              ele.subItems.forEach(subElement => {
                // 设置二级分类的fatherName为父级分类名称
                subElement.fatherName = item.name; // 新增
                if (element != null && element !== "" && element === subElement.onlyFlag && subElement.filterField) {
                  this.filterArray.push(subElement);
                }
              });
            }
          });
        });
      });

      // 如果有相同分类 合并
      var res = [];
      var narr = [];
      var metArr = [];
      for (var i = 0; i < this.filterArray.length; i++) {
        if (this.filterArray[i].fatherName != "资源来源") {
          const groupKey = JSON.stringify([this.filterArray[i].fatherName, this.filterArray[i].filterField]);
          var n = res.indexOf(groupKey);
          if (n == -1) {
            res.push(groupKey);
            narr.push({
              filterField: this.filterArray[i].filterField,
              fatherName: this.filterArray[i].fatherName,
              filterValue: [this.filterArray[i].filterValue],
              name: this.filterArray[i].name,
              onlyFlag: this.filterArray[i].onlyFlag,
            });
          } else {
            narr[n].filterValue.push(this.filterArray[i].filterValue);
          }
        } else {
          metArr.push({
            filterField: this.filterArray[i].filterField,
            fatherName: this.filterArray[i].fatherName,
            filterValue: [this.filterArray[i].filterValue],
            name: this.filterArray[i].name,
            onlyFlag: this.filterArray[i].onlyFlag,
          });
        }
      }
      narr = narr.concat(metArr);

      if (this.checkedLetterName) {
        narr.push(this.checkedLetterName);
        this.filterArray.push(this.checkedLetterName);
      }

      let obj = {
        filterArray: this.filterArray,
        newNarr: narr,
      };
      //选中的checkbox数组 传给父组件
      this.$emit("childByValue", obj);
    },
    // 根据学科信息自动选中对应的左侧聚合项
    selectSubjectByInfo(subjectInfo) {
      let found = false;
      this.leftDataGroup.forEach(item => {
        // 只处理外文学科
        if (item.name === "外文学科") {
          item.items.forEach((el, i) => {
            const nameMatches = el.name === subjectInfo.name;
            if (nameMatches) {
              if (!this.checkedGroup.includes(el.onlyFlag)) {
                // 使用Vue.set确保响应式更新
                this.$set(this, "checkedGroup", [...this.checkedGroup, el.onlyFlag]);
                found = true;
              }
            }
          });
        }
      });

      // 触发筛选更新
      if (found) {
        this.$nextTick(() => {
          this.handleCheckedGroup();
          // 强制更新视图以确保复选框状态同步
          this.$forceUpdate();
        });
      }
    },
    // 根据onlyFlag移除对应的复选框选中状态
    removeCheckboxByFlag(onlyFlag) {
      const index = this.checkedGroup.findIndex(item => item === onlyFlag);
      if (index !== -1) {
        this.checkedGroup.splice(index, 1);
        this.$forceUpdate();
        this.handleCheckedGroup();
      }
    },
    removeFilterItem(val) {
      if (!val || !val.onlyFlag) {
        return;
      }

      const removeValues = [val.onlyFlag];
      if (Array.isArray(val.filterValue)) {
        removeValues.push(...val.filterValue);
      } else if (val.filterValue) {
        removeValues.push(val.filterValue);
      }

      this.checkedGroup = this.checkedGroup.filter(element => !removeValues.includes(element));

      //如果删除了首字母选项 左侧聚合取消选中
      if (this.checkedLetterName && this.checkedLetterName.onlyFlag === val.onlyFlag) {
        this.checkedLetterName = "";
        this.letterNum = null;
      }

      // 处理预选中学科的删除
      if (this.preSelectedSubject) {
        // 查找对应的外文学科项的onlyFlag
        let preSelectedOnlyFlag = null;
        this.leftDataGroup.forEach(item => {
          if (item.name === "外文学科") {
            item.items.forEach(el => {
              if (el.name === this.preSelectedSubject.name) {
                preSelectedOnlyFlag = el.onlyFlag;
              }
            });
          }
        });

        // 如果删除的是预选中的学科项
        if (preSelectedOnlyFlag === val.onlyFlag) {
          this.preSelectedSubject = null;
          // 通知父组件清理sessionStorage
          this.$emit("clearPreSelectedSubject");
        }
      }

      // 强制更新视图以确保复选框状态同步
      this.$forceUpdate();
      this.handleCheckedGroup();
    },
  },
};
</script>

<style lang="scss" scoped>
.container_menu {
  max-width: 250px;
  position: relative;
  margin-right: 20px;
  min-height: 750px;
  width: 250px;
  .menu-letter {
    background: #fff;
    padding: 0 20px;
    margin-bottom: 10px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(90deg, #006eb3 0%, #2d8cf0 100%) #2d8cf0;
    }
    .checked {
      color: #2d8cf0;
    }
    .menu-title {
      padding: 15px 0;
      font-weight: 400;
    }
    .menu-num {
      border-top: 1px solid #e6e6e6;
      font-size: 14px;
      padding: 5px 0;
      cursor: pointer;
    }
    .menu-ul {
      flex-wrap: wrap;
      li {
        cursor: pointer;
        width: 30px;
        font-size: 14px;
        line-height: 25px;
      }
    }
    .menu-other {
      font-size: 14px;
      padding: 5px 0 10px 0;
      cursor: pointer;
    }
  }

  .menu {
    background: #fff;
    padding: 0 20px;
    margin-bottom: 10px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(90deg, #006eb3 0%, #2d8cf0 100%) #2d8cf0;
    }
    .menu-title {
      padding: 15px 0;
      font-weight: 400;
      i {
        margin-left: auto;
        font-size: 20px;
        color: #666;
        cursor: pointer;
      }
    }
    .menu-list {
      border-top: 1px solid #e6e6e6;
      font-size: 14px;
      padding-bottom: 20px;
      padding-top: 10px;
      max-height: 620px;
      overflow-y: auto;
      // 自定义滚动条样式
      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;

        &:hover {
          background: #a8a8a8;
        }
      }

      &::-webkit-scrollbar-corner {
        background: #f1f1f1;
      }

      // Firefox滚动条样式
      scrollbar-width: thin;
      scrollbar-color: #c1c1c1 #f1f1f1;
      li {
        align-items: center;
        margin-top: 10px;
        cursor: pointer;
        ::v-deep .el-checkbox {
          color: #333;
          display: flex;
          align-items: center;
          width: 100%;
        }
        ::v-deep .el-checkbox__label {
          display: flex;
          flex: 1;
          min-width: 0;
          font-weight: 400;
        }
        .menu-result {
          margin-left: auto;
          color: #999999;
        }
      }
    }
  }
  .fixed {
    position: fixed;
    top: 45%;
    left: 15%;
    background: #006eb3;
    width: 50px;
    color: #fff;
    font-size: 12px;
    padding: 10px;
    border-radius: 3px;
    text-align: center;
    box-shadow: 0px 0px 5px 0px rgba(161, 29, 29, 0.4);
    cursor: pointer;
    span {
      position: absolute;
      top: -10px;
      left: -10px;
      background: #006eb3;
      border: 1px solid #fff;
      border-radius: 50%;
      width: 20px;
      height: 20px;
    }
  }
}
.firstdiv {
  ul {
    list-style: none;
  }
  .arrows {
    margin-top: 10px;
    padding-left: 20px;
    i {
      margin-right: 10px;
      font-size: 18px;
      &.active {
        cursor: pointer;
      }
    }
  }
  img {
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
  .firstcheck {
    cursor: pointer;
    .facet-parent-label {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
      padding-left: 10px;
      height: 23px;
      font-size: 14px;
      font-weight: 400;
      column-gap: 8px;
      .tag-name {
        max-width: 130px;
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .menu-result {
        margin-left: auto;
        flex-shrink: 0;
        white-space: nowrap;
      }
    }
    align-items: center;
    > img {
      flex-shrink: 0;
    }
    ::v-deep .el-checkbox__input {
      display: none;
    }
  }
  .check-item ::v-deep .el-checkbox {
    display: flex;
    align-items: center;
    .el-checkbox__label {
      white-space: pre-wrap;
      word-break: break-all;
      display: flex;
      align-items: center;
      height: 23px;
      font-weight: 400;
    }
    .tag-name {
      max-width: 130px;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .menu-two {
    margin-left: 15px;
    .line1 {
      max-width: 120px;
      font-weight: 400;
    }
  }
}
</style>
